export class SellerServicesEntity {
  services;

  constructor(services) {
    this.services = this.#formatServices(services);
  }

  get cheapest() {
    return [...this.services].sort(
      (service, nextService) => service.price.raw - nextService.price.raw
    )[0];
  }

  #formatServices(services) {
    return services.map((service) => {
      return {
        ...service,
        price: {
          raw: service.price,
          formatted: new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(service.price),
        },
      };
    });
  }
}
